/*eslint-disable */

import PDFUploader from '@/components/common/pdfViewer/PDFUploader.vue'
import PDFViewer from '@/components/common/pdfViewer/PDFViewer.vue'
import {
  bus
} from '@/main';

var $ = window.jQuery = require('jquery');

export default {
  name: 'pdf-viewer',
  components: {
    PDFUploader,
    PDFViewer
  },
  props: [
    'pdfViewerURL',
    'pdfViewerFileNAME'
  ],
  data () {
    return {
      url:'',
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
    }
  },
  computed: {

  },
  mounted () {
    this.url = this.pdfViewerURL

  },
  methods: {
    downloadFileMethod(){
      var file = this.url
      setTimeout(() => {
        // Create a link and set the URL using `createObjectURL`
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = file;
        link.download = 'test';
      
        // It needs to be added to the DOM so it can be clicked
        document.body.appendChild(link);
        link.click();
      
        // To make this work on Firefox we need to wait
        // a little while before removing it.
        setTimeout(() => {
          URL.revokeObjectURL(link.href);
          link.parentNode.removeChild(link);
        }, 0);
      },100)
     },
    urlUpdated(url) {
      this.documentError = undefined;
    },
    onDocumentErrored(e) {
      this.documentError = e.text;
    },
    pdfViewerCloseFun(){
      bus.$emit('pdfViewerPopupBus', false);
      $('body').removeClass("overflow-hidden")
      $('body').removeClass("pdf_view_actv")
    },
  }
}


